<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert dense text class="body-2 mb-5" type="info">
      Berikut ini adalah menu unduhan rekap laporan bulanan, Silakan pilih laporan organisasi dan periode yang akan di
      unduh
    </v-alert>

    <v-card>
      <v-card-text>
        <label class="caption mb-2">Pilih Organisasi</label>
        <v-autocomplete
          v-model="org_id"
          :items="listOrganisasi"
          item-text="nama"
          item-value="kode_organisasi"
          placeholder="Pilih Laporan Organisasi"
          outlined
          dense
          @keydown="findOrgs"
        >
          <template v-slot:item="{ item }">
            <div>
              <v-list-item>
                <v-list-item-avatar>
                  <v-img :src="item.file_foto || 'img/tenant-default.png'"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ item.nama }}
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
          <template v-slot:selection="{ item }">
            <div>
              <v-list-item>
                <v-list-item-avatar>
                  <v-img :src="item.file_foto || 'img/tenant-default.png'"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div>{{ item.nama }}</div>
                  <div class="grey--text">{{ item.kode_organisasi }}</div>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
        </v-autocomplete>

        <v-select
          v-if="org_id"
          v-model="periode_id"
          :items="listPeriode"
          item-value="periode_laporan_id"
          item-text="nama"
          label="Pilih Periode"
          outlined
          dense
        >
        </v-select>

        <div v-if="periode_id" class="text-right">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="warning" dark depressed v-bind="attrs" v-on="on">
                {{ isTenant ? 'Proses' : 'Unduh' }} Laporan <v-icon right>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in unduhanList"
                :disabled="!isCan(item.akses)"
                :key="index"
                @click="onCetak(item)"
              >
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div class="my-2" v-if="isProsesData">
          <v-alert v-if="!Object.keys(objDownload).length" color="warning" dense text>
            <v-row align="center">
              <v-col class="grow">
                Unduhan belum bisa dilakukan, silakan tekan tombol <b>proses</b> untuk mengantrekan file unduhan
              </v-col>
              <v-col class="shrink">
                <v-btn color="primary" depressed dark @click="onProsesLaporan">Proses</v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <template v-else>
            <v-alert v-if="Number(objDownload.status) === 1" color="warning" dense text>
              <v-row align="center">
                <v-col class="grow">
                  Laporan masih di proses, silakan tunggu beberapa saat lagi, atau tekan tombol <b>muat ulang</b>
                </v-col>
                <v-col class="shrink">
                  <v-btn color="primary" depressed dark @click="onReloadLaporan">Muat ulang</v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-alert v-else-if="Number(objDownload.status) !== 2" color="warning" dense text>
              <v-row align="center">
                <v-col class="grow">
                  Laporan belum bisa di unduh, silakan di tunggu beberapa saat lagi atau tekan tombol
                  <b>proses ulang</b> untuk memperbarui file unduhan
                </v-col>
                <v-col class="shrink">
                  <v-btn color="primary" depressed dark @click="onProsesLaporan">Proses ulang</v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-card class="pa-0">
              <v-card-text class="pa-0">
                <v-list>
                  <v-list-item>
                    <v-list-item-icon class="my-auto">
                      <v-icon color="success" dark left size="40">mdi-file-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="my-auto">
                      <v-row no-gutters>
                        <v-col cols="12" md="12" sm="12">
                          <div>{{ objDownload && objDownload.nama }}</div>
                          <div class="caption">{{ pVal(objDownload, 'created_at') }}</div>
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <v-btn
                            v-if="isCan('tenant-laporan.unduh-file')"
                            color="primary"
                            :disabled="Number(objDownload.status) !== 2"
                            small
                            depressed
                            @click="onDownload"
                          >
                            Unduh Laporan
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            v-if="Number(objDownload.status) === 2"
                            color="success"
                            small
                            depressed
                            @click="onProsesLaporan"
                          >
                            Proses Ulang
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </template>
        </div>

        <table v-show="false" ref="table" id="rekap">
          <thead>
            <tr>
              <th rowspan="4">No</th>
              <th rowspan="4">Nama</th>
              <th rowspan="4">NIP</th>
              <th :colspan="kategoriKetidakhadiran.length * 2">
                Tingkat Ketidakhadiran Berdasarkan Rumus Skor
              </th>
              <th rowspan="4" width="10">Jumlah (%)</th>
              <th rowspan="4">Tingkat Kehadiran (%)</th>
            </tr>
            <tr>
              <th v-for="kategori in kategoriKetidakhadiran" :key="kategori.index" colspan="2" width="10">
                {{ kategori.nama }}
              </th>
            </tr>
            <tr>
              <th v-for="kategori in kategoriKetidakhadiran" :key="kategori.index" colspan="2">
                {{ kategori.satuan }}
              </th>
            </tr>
            <tr class="font-weight-bold">
              <template v-for="kategori in kategoriKetidakhadiran">
                <th :key="kategori.index">
                  {{ kategori.skor }}
                </th>
                <th :key="kategori.id">%</th></template
              >
            </tr>
            <!-- <tr class="font-weight-bold text-center">
             <td v-for="i in 17" :key="i">{{ i }}</td>
           </tr> -->
          </thead>
          <tbody>
            <tr v-for="(item, index) in presensi" :key="item.index">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ item.users.nama }}</td>
              <td>{{ item.users.no_pegawai || '' }}</td>
              <template v-for="itemTerlambat in item.rekap.skor">
                <td class="text-center" :key="`${itemTerlambat.id}` + item.id + Math.random()">
                  {{ itemTerlambat.skor_total }}
                </td>
                <td class="text-center" :key="`${itemTerlambat.id}` + item.nama + Math.random()">
                  {{ itemTerlambat.persen }}
                </td>
              </template>
              <td class="text-center">
                {{ item.rekap.jumlah[0].jumlah }}
                <!-- {{ totalPresentaseKeterlambatan(item.itemTerlambatHadir) }} -->
              </td>
              <td class="text-center">
                {{ item.rekap.jumlah[0].tingkat_presensi.toFixed(2) }}

                <!-- {{
                 100 - totalPresentaseKeterlambatan(item.itemTerlambatHadir)
               }} -->
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import XLSX from 'xlsx'

export default {
  data() {
    return {
      listOrganisasi: [],
      listPeriode: [],
      org_id: null,
      periode_id: null,
      presensi: [],
      kategoriKetidakhadiran: [],
      objDownload: {},
      isProsesData: false,
      jenisLaporan: null,
      debounce: null,
      keyword: '',
    }
  },
  activated() {
    this.presensi = []
    this.kategoriKetidakhadiran = []
    this.org_id = null
    this.periode_id = null
    this.load()
  },
  computed: {
    unduhanList() {
      return [
        {
          key: 'bulanan',
          label: 'Laporan Bulanan',
          akses: this.isTenant ? 'tenant-laporan.unduhan-terakhir' : 'presensi-rekap.download',
          jenis: 1,
        },
        {
          key: 'presentase',
          label: 'Persentase Kehadiran',
          akses: this.isTenant ? 'tenant-laporan.unduhan-terakhir' : 'presensi-rekap.download-persentase',
          jenis: 2,
        },
      ]
    },

    isTenant() {
      return this.tenant_id === this.org_id
    },
  },
  methods: {
    resetLaporan() {
      this.objDownload = {}
      this.isProsesData = false
      this.jenisLaporan = null
    },

    load() {
      this.$store.dispatch('organisasi/get', { count: 100, keyword: this.keyword }).then(({ data }) => {
        this.presensi = []
        this.kategoriKetidakhadiran = []
        this.listOrganisasi = (data && data.data) || []
        this.listOrganisasi.unshift({
          kode_organisasi: this.tenant_id,
          nama: 'Semua Organisasi',
        })
      })
    },

    loadPeriode(value) {
      if (!value) return
      const isTenant = this.tenant_id === value
      this.$store
        .dispatch(`laporan/${isTenant ? 'getPeriodeTenant' : 'getPeriode'}`, { organisasi_id: value, obj: {} })
        .then(({ data }) => {
          this.presensi = []
          this.kategoriKetidakhadiran = []
          this.periode_id = ''
          this.listPeriode = (data && data.data) || []
          this.resetLaporan()
        })
    },

    loadPresensi() {
      if (!this.periode_id) return
      if (this.org_id === this.tenant_id) return
    },

    onCetak(value) {
      this.resetLaporan()
      if (this.isTenant) {
        let params = {
          jenis: value.jenis,
          kode_tenant: this.tenant_id,
          periode_laporan_id: this.periode_id
        }

        this.$store.dispatch('laporan/laporanTerakhir', params).then(({ data }) => {
          this.objDownload = data || {}
          this.isProsesData = true
          this.jenisLaporan = value.jenis
        })

        return
      }

      if (value && value.key === 'bulanan') {
        this.onLaporanBulanan()
        return
      }

      if (this.org_id !== this.tenant_id) {
        this.onLaporanPersentase()
      }
    },

    onLaporanPersentase() {
      const periode = this.listPeriode.find((s) => Number(s.periode_laporan_id) === Number(this.periode_id))

      const payload = {
        organisasi_id: this.org_id,
        type: 'orgs',
        name: 'presensi/cetak/persentase',
        params: {
          periode_laporan_id: this.periode_id,
          tgl_awal: periode.tgl_mulai,
          tgl_akhir: periode.tgl_selesai,
        },
      }

      this.$store.dispatch('laporan/cetakLaporan', payload).then((url) => {
        window.open(url, '_blank')
      })
    },

    onLaporanBulanan() {
      const periode = this.listPeriode.find((s) => Number(s.periode_laporan_id) === Number(this.periode_id))
      const isAdmin = this.org_id === this.tenant_id

      const payload = {
        organisasi_id: isAdmin ? this.tenant_id : this.org_id,
        type: isAdmin ? 'tenant' : 'orgs',
        name: isAdmin ? 'laporan/rekap/download' : 'presensi/cetak',
        params: {
          periode_laporan_id: this.periode_id,
          tgl_awal: periode.tgl_mulai,
          tgl_akhir: periode.tgl_selesai,
        },
      }

      this.$store.dispatch('laporan/cetakLaporan', payload).then((url) => {
        window.open(url, '_blank')
      })
    },

    onProsesLaporan() {
      const mJenis = {
        1: 'laporan/rekap/download',
        2: 'laporan/persentase/download',
      }

      const periode = this.listPeriode.find((s) => Number(s.periode_laporan_id) === Number(this.periode_id))
      const payload = {
        organisasi_id: this.tenant_id,
        type: 'tenant',
        name: mJenis[this.jenisLaporan],
        params: {
          periode_laporan_id: this.periode_id,
          tgl_awal: periode.tgl_mulai,
          tgl_akhir: periode.tgl_selesai,
        },
      }

      this.$store
        .dispatch('laporan/prosesLaporan', payload)
        .then((resp) => {
          return resp
        })
        .then(() => {
          const params = {
            jenis: this.jenisLaporan,
            kode_tenant: this.tenant_id,
          }

          clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            this.$store.dispatch('laporan/laporanTerakhir', params).then(({ data }) => {
              this.objDownload = data || {}
              this.isProsesData = true
            })
          }, 2000)
        })
    },

    exportXls(type, fn, dl) {
      let columns = []
      for (let i = 5; i <= this.presensi.length + 4; i++) {
        columns.push(`C${i}`)
      }

      var elt = document.getElementById('rekap')
      var wb = XLSX.utils.table_to_book(elt, { sheet: 'Persentase Bulanan' })
      if (wb) {
        const names = wb['SheetNames']
        names.forEach((name) => {
          const sheets = wb['Sheets'][name] || {}
          let index = 0
          Object.keys(sheets).forEach((key) => {
            if (columns.includes(key)) {
              wb['Sheets'][name][key]['t'] = 'x'
              wb['Sheets'][name][key]['v'] = this.presensi[index]['users']['no_pegawai'] || ''
              index++
            }
          })
        })
      }

      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' })
        : XLSX.writeFile(wb, fn || 'Laporan Rekap Presensi Bulanan.' + (type || 'xlsx'))
    },

    onReloadLaporan() {
      const params = {
        jenis: this.jenisLaporan,
        kode_tenant: this.tenant_id,
        periode_laporan_id: this.periode_id,
      }

      this.$store.dispatch('laporan/laporanTerakhir', params).then(({ data }) => {
        this.objDownload = data || {}
        this.isProsesData = true
      })
    },

    onDownload() {
      const url = this.objDownload.id
      this.$store.dispatch('laporan/unduhLaporan', url).then((resp) => {
        if (resp) window.open(resp, '_blank')
      })
    },

    findOrgs(event) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.keyword = event.target.value || ''
        this.load()
      }, 1500)
    }
  },

  watch: {
    org_id: 'loadPeriode',
    periode_id: 'loadPresensi',
  },
}
</script>
